'use client';

import { addToOrderData, clearCart } from '@/redux/slices/cart.slice';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import AppStorage from '@/utils/helpers';
import AuthModal from '@/components/AuthModal';
import { CheckOut, UpdateCheckOut } from '@/services/cart.api';
import { ChevronRightIcon, MapIcon } from '@heroicons/react/24/outline';
import NoOutletModal from '@/components/NoOutletModal';
import { getErrorMessge } from '@/utils/helpers';
import { toast } from 'react-toastify';
import { usePathname, useRouter } from 'next/navigation';
import { useAppSelector } from '@/redux/hooks';
import OrderType from './OrderType';
import Modal from './Modal';
import LocationDetails from './LocationDetails';
import { hydrateUserLocation } from '@/redux/slices/userLocation.slice';
import { addToOutlet } from '@/redux/slices/category.slice';
import LocationWarning from './LocationWarning';

type CheckOutProps = {
  cartItem: any;
  price: number;
  closeModal: () => void;
  setCartTotalPrice: (price: number) => void;
};

const CheckoutTab = ({
  cartItem,
  price,
  closeModal,
  setCartTotalPrice,
}: CheckOutProps) => {
  const outlet = JSON.parse(AppStorage.get('outlet') as string);
  const { cart: myCart } = useSelector((state: any) => state.cart);
  const { location } = useSelector((state: any) => state.userLocation);
  const [showNoOutletModal, setShowNoOutletModal] = useState(false);
  const { user, isAuthenticated } = useAppSelector((state) => state.auth);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validateCouponLoading, setValidateCouponLoading] = useState(false);
  const [callOrderType, setCallOrderType] = useState<boolean>(false);
  const [openLocation, setOpenLocation] = useState<boolean>(false);
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [branch, setBranch] = useState('');
  const [branches, setBranches] = useState<
    {
      _id: string;
      name: string;
      city: string;
      location: { coordinates: [number, number] };
      state?: string;
    }[]
  >([]);
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  // const [coupon, setCoupon] = useState('');
  const [couponValue, setCouponValue] = useState({
    isValid: false,
    value: 0,
  });
  const [openLogin, setOpenLogin] = useState({
    open: false,
    state: '',
  });
  const dispatch = useDispatch();
  const router = useRouter();
  const { coupon } = useSelector((state: any) => state.cart);
  const pathname = usePathname();
  const isSelfService = pathname.split('/').length === 3;
  const orderid = AppStorage.get('orderId') as string;
  // const location = useSelector((state: any) => state.userLocation);
  useEffect(() => {
    if (price === 0) {
      setOpenLocation(true);
      // setCallOrderType(true);
    }
  }, [price]);
  const checkOut = async () => {
    const orderType = AppStorage.get('orderType');

    const menuItems = myCart?.map((cartItem: any) => ({
      menuId: cartItem.id,
      quantity: cartItem.quantity,
    }));
    try {
      setLoading(true);
      if (isAuthenticated) {
        const lat = outlet?.location?.coordinates?.[1] || location?.lat;
        const lng = outlet?.location?.coordinates?.[0] || location?.lng;

        if (!lat || !lng) {
          throw new Error('Location coordinates are missing');
        }

        const payload = {
          latitude: lat.toString(),
          longitude: lng.toString(),
          orderType: orderType,
          couponCode: coupon,
          menuItems,
          orderSource: isSelfService ? 'SLS' : 'WEB',
          userid: user?._id,
          ...(!isSelfService && { order_id: orderid }),
          ...(isSelfService && { channels: ['bank_transfer'] }),
        };
        const res = isSelfService
          ? await CheckOut(payload)
          : await UpdateCheckOut(payload);

        dispatch(addToOrderData(res));

        AppStorage.save('orderId', res.serializedOrder._id);
        isSelfService &&
          AppStorage.save('paystackUrl', res.data.authorization_url);
      }
      if (!coupon) {
        AppStorage.remove('coupon_type');
        AppStorage.remove('coupon_rate');
        AppStorage.remove('coupon_code');
        AppStorage.remove('couponPrice');
      }

      isSelfService ? router.push('/checkout-sls') : router.push('/checkout');
    } catch (error) {
      console.error(error);
      const errorMsg = getErrorMessge(error) || String(error);

      // Check for the minified Safari error or our custom error
      if (
        errorMsg.includes('location.coordinates') ||
        errorMsg.includes('Location coordinates are missing') ||
        errorMsg.includes('undefined is not an object')
      ) {
        setOpenLocation(true);
        toast.error('Please set your location to proceed with checkout.');
      } else {
        toast.error(errorMsg);
      }
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  const handleLocation = () => {
    const selectedBranch = branches.find(
      (branchObj: any) => branchObj.name === branch
    );
    console.log(selectedBranch);
    dispatch(addToOutlet(selectedBranch));

    const location = {
      id: selectedBranch?._id ?? '',
      address: selectedBranch?.name ?? '',
      street: '',
      city: selectedBranch?.city ?? '',
      name: selectedBranch?.city ?? '',
      state: selectedBranch?.state ?? '',
      lat: selectedBranch?.location?.coordinates[1] ?? 0,
      lng: selectedBranch?.location?.coordinates[0] ?? 0,
    };

    dispatch(hydrateUserLocation(location));
    AppStorage.save('location', JSON.stringify(location));
  };

  return (
    <section className="bg-white px-4 py-5 flex flex-col">
      {/* {callOrderType && <OrderType />} */}
      <Modal
        closeModal={() => setOpenLocation(false)}
        openModal={openLocation}
        modalTitle="Hey Cruncher!"
        shouldCloseOnOverlayClick={false}
        closeButton
      >
        {/* <LocationInput /> */}
        <LocationDetails
          setState={setState}
          state={state}
          setCity={setCity}
          city={city}
          setBranch={setBranch}
          branch={branch}
          setBranches={setBranches}
          setShowWarning={setShowWarning}
        />

        <OrderType />
        <button
          className="text-white flex gap-2 items-center bg-crunchies-red shadow px-5 py-3 w-max mx-auto rounded-full"
          onClick={() => {
            // const newLocation = JSON.parse(
            //   AppStorage.get('location') as string
            // );
            // setLocation(newLocation);
            // dispatch(updateUserLocation(newLocation));
            handleLocation();
            // setViewModal((prev) => ({ ...prev, location: false }));
            setOpenLocation(false);
            // setCallOrderType(true);
          }}
        >
          <MapIcon className="w-6" />
          <div>Set location</div>
        </button>
      </Modal>
      {/* {showWarning && <LocationWarning setShowWarning={setShowWarning} />} */}
      <Modal
        openModal={showWarning}
        closeModal={() => setShowWarning(false)}
        modalTitle=""
        closeButton={true}
        shouldCloseOnOverlayClick={true}
      >
        <LocationWarning />
      </Modal>
      <section>
        <ul className="flex flex-col gap-3 text-base font-semibold py-6">
          <li className="flex justify-between">
            <p>Total</p>
            <p>₦{price.toLocaleString()}</p>
          </li>
          <li>
            <button
              onClick={checkOut}
              className="flex cursor-pointer items-center rounded-full text-center bg-primary-500 py-4 px-6 font-medium w-full text-white "
            >
              <span className="grow">
                {loading ? 'Loading...' : 'Checkout'}
              </span>
              <ChevronRightIcon className="w-6 h-6" />
            </button>
          </li>
        </ul>
      </section>
      <NoOutletModal
        open={showNoOutletModal}
        closeModal={() => {
          setShowNoOutletModal(false);
        }}
      />
    </section>
  );
};

export default CheckoutTab;
